// src/component/PortalPage.js
import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// ヘッダーリンク 1行目
const HEADER_LINKS = [
  { label: "音源", path: "/home" },
  { label: "光の柱", path: "/riteoflight" },
  { label: "cocozute", path: "/home", underline: true },
  { label: "事務局", path: "/contactPage" },
];

// ヘッダーリンク 2行目
const HEADER_LINKS_ROW2 = [
  { label: "DDPランダム", path: "/ddp" },
  { label: "新月会＆満月会", path: "/home" },
];

// ナビゲーションボタン
const NAV_BUTTONS = [
  { label: "グループ", path: "/home", type: "blue" },
  { label: "cotozute", path: "/home", type: "blue" },
  { label: "マイページ", path: "/mypage", type: "blue" },
  { label: "部活", path: "/home", type: "blue" },
  { label: "イベント", path: "/events", type: "blue" },
  { label: "マップ", path: "/village-map", type: "blue" },
  { label: "太陽", path: "/home", type: "warm" },
  { label: "地球", path: "/home", type: "warm" },
  { label: "月", path: "/home", type: "warm" },
];

// 事務局からのお知らせ
const ANNOUNCEMENTS = [
  {
    date: "2024.05.20",
    text: "新しいオンラインコース「月のリズムと生活デザイン」の受付を開始しました。",
  },
  {
    date: "2024.05.15",
    text: "次回の満月オンライン会議のスケジュールが決まりました。詳細はメンバー専用ページをご覧ください。",
  },
  {
    date: "2024.05.01",
    text: "サイトをリニューアルしました。オンラインスクールの情報をより分かりやすくお届けします。",
  },
];

// フッターナビ
const FOOTER_NAV = [
  { label: "ホーム", path: "/portal" },
  { label: "地球の活動", path: "/portal" },
  { label: "太陽の活動", path: "/portal" },
  { label: "月の活動", path: "/portal" },
  { label: "イベント", path: "/events" },
];

export default function PortalPage() {
  const navigate = useNavigate();
  // 固定カラー
  const t = {
    pageBg: "#f5f5f7",
    textPrimary: "#222",
    textSecondary: "#666",
    textLink: "#1976d2",
    topBtnBg: "#fff",
    topBtnBorder: "#999",
    navBlue: "#dbe6f6",
    navWarm: "#f0e0d6",
    navBorder: "#bbb",
    navText: "#333",
    moonWrap: "#c8cfe6",
    moonCard: "#fff",
    moonText: "#333",
    announceTitle: "#222",
    announceDivider: "#ccc",
    footerBg: "#eae8e0",
    footerText: "#333",
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: t.pageBg,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pt: { xs: 2, sm: 4 },
        px: 2,
        pb: 6,
        transition: "background 0.4s ease",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 648, overflow: "hidden" }}>
        {/* ── ヘッダー ── */}
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            gap: 2,
            mb: 4,
          }}
        >
          <Box
            onClick={() => navigate("/home")}
            sx={{
              border: `1px solid ${t.topBtnBorder}`,
              borderRadius: "4px",
              px: 2.5,
              py: 0.8,
              cursor: "pointer",
              fontWeight: 600,
              fontSize: 15,
              bgcolor: t.topBtnBg,
              color: t.textPrimary,
              userSelect: "none",
              transition: "all 0.3s ease",
              "&:hover": { opacity: 0.8 },
            }}
          >
            TOP
          </Box>

          <Box sx={{ lineHeight: 1.9, textAlign: "center" }}>
            <Box>
              {HEADER_LINKS.map((link, i) => (
                <React.Fragment key={link.label}>
                  <Typography
                    component="span"
                    onClick={() => navigate(link.path)}
                    sx={{
                      fontSize: 13,
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                      textDecoration: link.underline ? "underline" : "none",
                      color: link.underline ? t.textLink : t.textSecondary,
                      "&:hover": { opacity: 0.7 },
                    }}
                  >
                    {link.label}
                  </Typography>
                  {i < HEADER_LINKS.length - 1 && (
                    <Typography component="span" sx={{ fontSize: 13, mx: 0.3, color: t.textSecondary }}>
                      /
                    </Typography>
                  )}
                </React.Fragment>
              ))}
            </Box>
            <Box>
              {HEADER_LINKS_ROW2.map((link, i) => (
                <React.Fragment key={link.label}>
                  <Typography
                    component="span"
                    onClick={() => navigate(link.path)}
                    sx={{
                      fontSize: 13,
                      cursor: "pointer",
                      color: t.textSecondary,
                      transition: "color 0.3s ease",
                      "&:hover": { opacity: 0.7 },
                    }}
                  >
                    {link.label}
                  </Typography>
                  {i < HEADER_LINKS_ROW2.length - 1 && (
                    <Typography component="span" sx={{ fontSize: 13, mx: 0.3, color: t.textSecondary }}>
                      /
                    </Typography>
                  )}
                </React.Fragment>
              ))}
            </Box>
          </Box>
        </Box>

        {/* ── ナビゲーションボタン群 ── */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1.5,
            justifyContent: "center",
            mb: 5,
          }}
        >
          {NAV_BUTTONS.map((btn) => (
            <Box
              key={btn.label}
              onClick={() => navigate(btn.path)}
              sx={{
                border: `1px solid ${t.navBorder}`,
                borderRadius: "4px",
                px: { xs: 2, sm: 3 },
                py: 1,
                bgcolor: btn.type === "blue" ? t.navBlue : t.navWarm,
                cursor: "pointer",
                fontSize: { xs: 13, sm: 15 },
                fontWeight: 500,
                color: t.navText,
                whiteSpace: "nowrap",
                userSelect: "none",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-1px)",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                },
              }}
            >
              {btn.label}
            </Box>
          ))}
        </Box>

        {/* ── 月のセクション ── */}
        <Box
          sx={{
            bgcolor: t.moonWrap,
            borderRadius: 4,
            p: { xs: 2, sm: 4 },
            mb: 5,
            transition: "background 0.4s ease",
          }}
        >
          <Box
            sx={{
              bgcolor: t.moonCard,
              borderRadius: 3,
              p: { xs: 3, sm: 5 },
              textAlign: "center",
              transition: "background 0.4s ease",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: { xs: 3, sm: 6 },
                mb: 4,
              }}
            >
              <Box
                sx={{
                  width: { xs: 120, sm: 200 },
                  height: { xs: 120, sm: 200 },
                  borderRadius: "50%",
                  background: "radial-gradient(circle at 40% 40%, #e8d5a0, #c4a55a, #8a6e3a)",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                }}
              />
              <Box
                sx={{
                  width: { xs: 120, sm: 200 },
                  height: { xs: 120, sm: 200 },
                  borderRadius: "50%",
                  background: "radial-gradient(circle at 60% 40%, #e0ddd8, #b0aaa0, #7a7570)",
                  boxShadow: t.key === "night"
                    ? "0 0 30px rgba(180,180,200,0.3)"
                    : "0 4px 20px rgba(0,0,0,0.15)",
                }}
              />
            </Box>

            <Typography sx={{ fontSize: { xs: 13, sm: 15 }, lineHeight: 2, color: t.moonText, mb: 2, transition: "color 0.3s ease" }}>
              『新月の日の朝』と『満月の日の夜』に
              <br />
              オンラインで全国の拠点を繋いでZOOM会議を行なっています。
            </Typography>
            <Typography sx={{ fontSize: { xs: 13, sm: 15 }, lineHeight: 2, color: t.moonText, mb: 2, transition: "color 0.3s ease" }}>
              同じ県に住むメンバーと連絡を取り合い、
              <br />
              「拠点」で集まりご参加ください
            </Typography>
            <Typography sx={{ fontSize: { xs: 13, sm: 15 }, lineHeight: 2, color: t.moonText, transition: "color 0.3s ease" }}>
              繰り返し『新月の日』と『満月の日』に会うことで、
              <br />
              「月のリズム」を通した同期現象によって
              <br />
              地球のナカマと心から繋がり合えます。
            </Typography>
          </Box>
        </Box>

        {/* ── 事務局からのお知らせ ── */}
        <Box sx={{ mb: 5 }}>
          <Typography
            sx={{
              fontSize: { xs: 22, sm: 28 },
              fontWeight: 800,
              textAlign: "center",
              mb: 4,
              color: t.announceTitle,
              transition: "color 0.3s ease",
            }}
          >
            事務局からのお知らせ
          </Typography>

          {ANNOUNCEMENTS.map((item, i) => (
            <Box key={i}>
              <Divider sx={{ borderColor: t.announceDivider, transition: "border-color 0.3s ease" }} />
              <Box sx={{ py: 3, px: { xs: 1, sm: 2 } }}>
                <Typography sx={{ fontSize: 13, color: t.textSecondary, mb: 1, transition: "color 0.3s ease" }}>
                  {item.date}
                </Typography>
                <Typography sx={{ fontSize: { xs: 13, sm: 15 }, color: t.textPrimary, lineHeight: 1.7, transition: "color 0.3s ease" }}>
                  {item.text}
                </Typography>
              </Box>
            </Box>
          ))}
          <Divider sx={{ borderColor: t.announceDivider }} />
        </Box>

        {/* ── フッターナビ ── */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0,
            bgcolor: t.footerBg,
            borderRadius: 1,
            overflow: "hidden",
            transition: "background 0.4s ease",
          }}
        >
          {FOOTER_NAV.map((item) => (
            <Box
              key={item.label}
              onClick={() => navigate(item.path)}
              sx={{
                px: { xs: 1.5, sm: 3 },
                py: 1.5,
                cursor: "pointer",
                fontSize: { xs: 11, sm: 14 },
                color: t.footerText,
                textDecoration: item.label === "ホーム" ? "underline" : "none",
                whiteSpace: "nowrap",
                transition: "color 0.3s ease",
                "&:hover": { bgcolor: "rgba(128,128,128,0.1)" },
              }}
            >
              {item.label}
            </Box>
          ))}
          <Box
            sx={{
              px: { xs: 1, sm: 2 },
              py: 1.5,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              "&:hover": { bgcolor: "rgba(128,128,128,0.1)" },
            }}
          >
            <ChevronRightIcon sx={{ fontSize: 20, color: t.footerText }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
